export default "<app-recomendaciones [disabled]=\"disabled\" [products]=\"products\" ></app-recomendaciones>\n";